import { render } from "./NkButton.vue?vue&type=template&id=38ba75fd"
import script from "./NkButton.vue?vue&type=script&lang=js"
export * from "./NkButton.vue?vue&type=script&lang=js"
script.render = render

export default script